import type { AnyType } from '@/lib/helpers';
import { getRectangle } from '@/lib/pack';
import { ref } from 'vue';

export const settings = ref<AnyType>(null);

/**
 * Параметры изделий.
 */
export const products = ref<AnyType[]>([]);

/**
 * Заготовленные материалы (точнее: форматы одного материала)
 */
export const sourceMaterials = ref<AnyType[]>([]);

export const newSample = ref<AnyType>(null);

export function getRectangles() {
	return products.value.map(prod => {
		// TODO изделие это не элемент (в раскладке на рулон изделия могут резаться на несколько элементов, если целиком не помещается на печатный лист)
		return getRectangle(prod.width, prod.height, prod.count, prod.fibers, prod.comment, prod.id);
	});
}

export function getSourceMaterial(size1?: number, size2?: number) {
	return {
		size1: size1 || 0,
		size2: size2 || 0,
	};
}

export function getSourceMaterialsFlat() {
	return sourceMaterials.value.map(function (sourceMaterial) {
		return [sourceMaterial.size1, sourceMaterial.size2];
	});
}

export function addSourceMaterial(size1?: number, size2?: number) {
	sourceMaterials.value.push(getSourceMaterial(size1, size2));
}

export function getProduct(w?: number, h?: number, count?: number, fibers?: boolean, comment?: string) {
	return {
		width: w || 0,
		height: h || 0,
		count: count || 1,
		fibers: fibers || false,
		comment: comment || '',
		id: btoa(Math.random().toString()),
	};
}

export function addProduct(w?: number, h?: number, count?: number, fibers?: boolean, comment?: string) {
	products.value.push(getProduct(w, h, count, fibers, comment));
}

export function setPack(_settings: AnyType, rectangles: AnyType[], sourceMaterialsFlat?: AnyType[]) {
	if (_settings) {
		settings.value = _settings;
	}

	if (rectangles && rectangles.length > 0) {
		products.value = [];
		rectangles.forEach(rect => {
			// FIXME изделие это не элемент, изделие может состоять из элементов в зависимости от размеров материала и печатного листа (для рулонной будет возможность склейки)
			addProduct(rect.width, rect.height, rect.count || 1, rect.fibers || false, rect.comment || '');
		});
	}

	if (sourceMaterialsFlat && sourceMaterialsFlat.length > 0) {
		sourceMaterials.value = [];
		sourceMaterialsFlat.forEach(sourceMaterial => {
			addSourceMaterial(sourceMaterial[0], sourceMaterial[1]);
		});
	}
}

export function getNewSample() {
	return {
		name: { edit: '' },
		dataSettings: settings.value,
		dataRectangles: getRectangles(),
		dataMaterials: getSourceMaterialsFlat(),
	};
}
